<div class="p-3 box h-100 overflow-auto crm-scroll">
  <h1>{{ 'store' | translate }}</h1>

  <div>
    <div class="d-flex flex-wrap gap-4">
      <ng-container [ngTemplateOutlet]="app"></ng-container>
    </div>
  </div>
</div>

<ng-template #app>
  @for (app of applications; track app) {
    <div class="app-box d-flex justify-content-between flex-column gap-4">
      @if (app.is_beta) {
        <span class="chip beta">{{ 'test_regime' | translate }}</span>
      }
      <div style="height: 60%">
        <div
          class="image-box click-css"
          (click)="onClick(app.key, app.status === APPLICATION_STATUS.INSTALLED)"
          [ngStyle]="{
            '--bg-color': app.json.bg_color,
            '--text-market-color': app.json.text_color,
          }"
        >
          <span>{{ app.title }}</span>
        </div>
        <div class="info-box px-4 py-2">
          <div class="title pb-2">
            {{ app.json.name }}
          </div>
          <div class="desc">
            {{ app.description }}
          </div>
        </div>
      </div>
      @if (!app.is_loader) {
        @if (app.status !== APPLICATION_STATUS.INSTALLED) {
          @if (!app.price || [APPLICATION_STATUS.READY, APPLICATION_STATUS.UNINSTALLED].includes(app.status)) {
            <div (click)="onDownload(app, $event)" class="button-download click-css p-2 m-2 gap-2">
              <span>{{ 'install' | translate }}</span>
              <app-icon>download</app-icon>
            </div>
          }
          @if (false && app.next_payment_at && moment().isAfter(moment(app.next_payment_at))) {
            <div (click)="onPay(app)" class="button-download click-css p-2 m-2 gap-2">
              <span>{{ 'buy' | translate }}</span>
              <span>{{ parseCurrency(app.price, 'USD') }}</span>
              <!--          <app-icon>download</app-icon>-->
            </div>
          }
          @if (app.price && app.status === APPLICATION_STATUS.WAIT_MANAGER) {
            <div class="button-download p-2 m-2">
              <span>{{ 'wait_for_confirmation' | translate }}</span>
            </div>
          }
        }
        @if (app.status === APPLICATION_STATUS.INSTALLED) {
          <div class="d-flex m-2 align-self-end gap-2">
            @if (['RINGOSTAT', 'TELEGRAM_BOT', 'NOVA_POSHTA', 'VCHASNO_KASA'].includes(app.key)) {
              <div (click)="onConfigure(app)" class="button-downloaded click-css p-2">
                <app-icon>settings</app-icon>
              </div>
            }
            <div (click)="onDelete(app)" class="button-downloaded click-css p-2">
              <app-icon>delete_outline</app-icon>
            </div>
            <div (click)="onClick(app.key)" class="button-downloaded click-css p-2">
              <span class="px-3">{{ 'open' | translate }}</span>
              <!--        <app-icon>download</app-icon>-->
            </div>
          </div>
        }
      } @else {
        <div class="button-downloading flex-column click-css m-2">
          <span class="p-2">{{ 'installation' | translate }}</span>
          <!--        <app-icon>download</app-icon>-->
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  }
</ng-template>
